import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ButtonSaveFile from '../components/controls/ButtonSaveFile'
import * as actions from '../store/actions'
import HeaderStyle from '../styles/HeaderStyle'
import ConfirmationDialog from '../containers/ConfirmationDialog'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'

const ITEM_HEIGHT = 48

class Header extends Component {
  state = {
    anchorEl: null,
    openXMLConfirmationVisible: false,
    newFileConfirmationVisible: false,
  }

  options = [
    {
      title: 'OTWÓRZ PLIK',
      action: () => {
        this.handleConfirmationOpen(true)
      },
    },
    {
      title: 'UTWÓRZ NOWE E-SPRAWOZDANIE',
      action: () => {
        this.handleConfirmationOpen()
      },
    },
    {
      title: 'SPRAWDŹ POPRAWNOŚĆ',
      action: () => {
        this.props.onCheckValidity(this.props.fileId, this.props.sections)
      },
    },
    {
      title: 'DRUKUJ',
      action: () => {
        this.props.onGetReport(this.props.fileId, this.props.sections)
      },
    },
  ]

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  handleConfirmationClose = loadXML => {
    if (loadXML) this.setState({ openXMLConfirmationVisible: false })
    else this.setState({ newFileConfirmationVisible: false })
  }

  handleConfirmationOpen = loadXML => {
    if (loadXML) this.setState({ openXMLConfirmationVisible: true })
    else this.setState({ newFileConfirmationVisible: true })
  }

  render() {
    const { anchorEl } = this.state
    const {
      name,
      fileId,
      sections,
      licencja,
      validityErrors,
      onCheckValidity,
      onSetCzyWyborDaty,
      onZakupLicencji,
      czyPodsumowanie,
      onDownloadSections,
    } = this.props
    const open = Boolean(anchorEl)
    return (
      <HeaderStyle>
        <h1>{name}</h1>
        {czyPodsumowanie && (
          <div className="buttons">
            <Button
              variant="contained"
              color="primary"
              onClick={() => window.print()}
            >
              DRUKUJ
            </Button>
            <Button
              className="spanTwoColumns"
              variant="outlined"
              color="primary"
              onClick={() => onDownloadSections(fileId, 1)}
            >
              POWRÓT
            </Button>
          </div>
        )}
        {!czyPodsumowanie && (
          <div className="buttons">
            {licencja &&
            licencja.system === 'ESPR' &&
            licencja.status !== '0' ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => onZakupLicencji()}
              >
                KUP LICENCJĘ
              </Button>
            ) : sections[0].TypSekcji !== 'Walidacja' ||
              (validityErrors && validityErrors.length) ? (
              <ButtonSaveFile
                variant={
                  sections[0].TypSekcji === 'Walidacja'
                    ? 'outlined'
                    : 'contained'
                }
                checkValidity
              />
            ) : null}
            {validityErrors &&
            validityErrors.length &&
            sections[0].TypSekcji === 'Walidacja' ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => onCheckValidity(fileId)}
              >
                SPRAWDŹ POPRAWNOŚĆ
              </Button>
            ) : null}
            <Button
              className={
                sections[0].TypSekcji !== 'Walidacja'
                  ? 'moreButton spanTwoColumns'
                  : validityErrors && validityErrors.length
                  ? 'moreButton'
                  : licencja.system === 'ESPR' || licencja.status !== '0'
                  ? 'moreButton spanTwoColumns'
                  : 'moreButton spanThreeColumns'
              }
              aria-label="More"
              aria-owns={open ? 'long-menu' : undefined}
              aria-haspopup="true"
              onClick={this.handleClick}
              variant="outlined"
              color="primary"
            >
              <MoreHorizIcon />
            </Button>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={this.handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                },
              }}
            >
              {this.options.map(option => (
                <MenuItem
                  key={option.title}
                  onClick={this.handleClose}
                  onMouseUp={option.action}
                >
                  {option.title}
                </MenuItem>
              ))}
            </Menu>
            <ConfirmationDialog
              loadXML={true}
              isError={this.state.openXMLConfirmationVisible}
              onClose={() => this.handleConfirmationClose(true)}
            />
            <ConfirmationDialog
              isError={this.state.newFileConfirmationVisible}
              onContinue={() => onSetCzyWyborDaty(true)}
              onClose={() => this.handleConfirmationClose()}
            />
          </div>
        )}
      </HeaderStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    licencja: state.sprawozdanie.licencja,
    fileId: state.sprawozdanie.header.Id,
    name: state.sprawozdanie.name,
    sections: state.sprawozdanie.sections,
    validityErrors: state.sprawozdanie.validityErrors,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCheckValidity: (fileId, sections) =>
      dispatch(actions.checkValidity(fileId, sections)),
    onZakupLicencji: () => dispatch(actions.setZakupLicencji(true)),
    onSetCzyWyborDaty: x => dispatch(actions.setCzyWyborDaty(x)),
    onGetReport: (fileId, sections) =>
      dispatch(actions.getReport(fileId, sections)),
    onDownloadSections: (id, page) =>
      dispatch(actions.downloadSections(id, page)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header)
